import * as _ from 'lodash';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[alphanumericsOnly]',
    standalone: false
})
export class AlphanumericsOnlyDirective {
    // Allow alphanumerics
    private regex = new RegExp(/^[a-z0-9]+$/i);

    // Allow key codes for special events
    private specialKeys = ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];

    constructor(private el: ElementRef) {}

    @HostListener('paste', ['$event'])
    onPaste(event: KeyboardEvent) {
        event.preventDefault();
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        // Look into the input or the closest input inside of the element
        const current: string = !_.isUndefined(this.el.nativeElement.value)
            ? this.el.nativeElement.value
            : this.el.nativeElement.querySelector('input').value;
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        const next: string = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}
